/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Education } from '../../models/education';

export interface GetEducations$Params {
  profileId: string;
}

export function getEducations(http: HttpClient, rootUrl: string, params: GetEducations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Education>>> {
  const rb = new RequestBuilder(rootUrl, getEducations.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Education>>;
    })
  );
}

getEducations.PATH = '/studentprofile/{profileId}/education';
